import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "../../assets/css/vendors/HotelScreens/hotelAnalytics.css";
import VendorLayout from "../../layout/HotelVendorLayout/VendorLayout";

const HotelAnalytics = () => {
  const monthlyData = [
    { month: "Jan", revenue: 450000, expenses: 150000, profit: 300000 },
    { month: "Feb", revenue: 520000, expenses: 180000, profit: 340000 },
    { month: "Mar", revenue: 380000, expenses: 160000, profit: 220000 },
    { month: "Apr", revenue: 620000, expenses: 200000, profit: 420000 },
    { month: "May", revenue: 650000, expenses: 220000, profit: 430000 },
    { month: "Jun", revenue: 580000, expenses: 210000, profit: 370000 },
    { month: "Jul", revenue: 720000, expenses: 250000, profit: 470000 },
    { month: "Aug", revenue: 680000, expenses: 230000, profit: 450000 },
    { month: "Sep", revenue: 750000, expenses: 260000, profit: 490000 },
    { month: "Oct", revenue: 800000, expenses: 280000, profit: 520000 },
    { month: "Nov", revenue: 850000, expenses: 300000, profit: 550000 },
    { month: "Dec", revenue: 900000, expenses: 320000, profit: 580000 },
  ];

  const roomData = [
    { type: "Standard", revenue: 1200000 },
    { type: "Deluxe", revenue: 1800000 },
    { type: "Suite", revenue: 1400000 },
    { type: "Presidential", revenue: 400000 },
  ];

  // Custom Tooltip function to show Rs. with names
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">Month: {label}</p>
          {payload.map((entry, index) => (
            <p
              key={index}
              className="tooltip-item"
              style={{ color: entry.color }}
            >
              {entry.name}: Rs. {entry.value.toLocaleString("en-IN")}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <VendorLayout>
      <div className="analytics-page">
        {/* Header */}
        <div className="analytics-header">
          <h2>Revenue Analytics</h2>
          <p>Monthly revenue, expenses and profit analysis</p>
        </div>

        <Row className="mb-4">
          {/* Area Chart - Revenue, Expenses, Profit */}
          <Col lg={8} className="mb-4">
            <Card>
              <Card.Body>
                <h5>Monthly Performance</h5>
                <div style={{ height: "400px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={monthlyData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                      <XAxis dataKey="month" stroke="#666" />
                      <YAxis
                        stroke="#666"
                        tickFormatter={(value) => `₹${value / 1000}k`}
                      />
                      <Tooltip content={<CustomTooltip />} />
                      <Legend />
                      <Area
                        type="monotone"
                        dataKey="revenue"
                        name="Revenue"
                        stroke="#2C5F7C"
                        fill="#2C5F7C"
                        fillOpacity={0.3}
                      />
                      <Area
                        type="monotone"
                        dataKey="expenses"
                        name="Expenses"
                        stroke="#FFB800"
                        fill="#FFB800"
                        fillOpacity={0.3}
                      />
                      <Area
                        type="monotone"
                        dataKey="profit"
                        name="Profit"
                        stroke="#4CAF50"
                        fill="#4CAF50"
                        fillOpacity={0.3}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Bar Chart */}
          <Col lg={4} className="mb-4">
            <Card>
              <Card.Body>
                <h5>Revenue by Room Type</h5>
                <div style={{ height: "400px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={roomData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                      <XAxis dataKey="type" stroke="#666" />
                      <YAxis
                        stroke="#666"
                        tickFormatter={(value) => `₹${value / 1000000}M`}
                      />
                      <Tooltip
                        formatter={(value, name) => [
                          `Rs. ${value.toLocaleString("en-IN")}`,
                          "Revenue",
                        ]}
                      />
                      <Bar
                        dataKey="revenue"
                        name="Revenue"
                        fill="#FFB800"
                        radius={[4, 4, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Line Chart */}
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <h5>Revenue Trend</h5>
                <div style={{ height: "300px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={monthlyData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                      <XAxis dataKey="month" stroke="#666" />
                      <YAxis
                        stroke="#666"
                        tickFormatter={(value) => `₹${value / 1000}k`}
                      />
                      <Tooltip
                        formatter={(value, name) => [
                          `Rs. ${value.toLocaleString("en-IN")}`,
                          "Revenue",
                        ]}
                      />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="revenue"
                        name="Revenue"
                        stroke="#2C5F7C"
                        strokeWidth={3}
                        dot={{ r: 4 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </VendorLayout>
  );
};

export default HotelAnalytics;
